import { IProcessPartnersState } from './process-partners.state';
import { createReducer, on } from '@ngrx/store';
import {
  loadProcessPartnerById,
  loadProcessPartnerByIdFailure,
  loadProcessPartnerByIdSuccess,
  loadProcessPartners,
  loadProcessPartnersFailure,
  loadProcessPartnersSuccess,
  searchProcessPartners,
  searchProcessPartnersFailure,
  searchProcessPartnersSuccess,
  setProcessPartnerInactive,
  setProcessPartnerInactiveSuccess,
} from './process-partners.actions';

export const initialState: IProcessPartnersState = {
  processPartners: [],
  processPartner: null,
  loading: false,
  error: null,
  buttonLoading: false,
};

export const processPartnersReducer = createReducer(
  initialState,
  on(loadProcessPartners, (state) => {
    return {
      ...state,
      loading: true,
    };
  }),
  on(loadProcessPartnersSuccess, (state, { processPartners }) => {
    return {
      ...state,
      processPartners,
      loading: false,
    };
  }),
  on(loadProcessPartnersFailure, (state) => {
    return {
      ...state,
      loading: false,
    };
  }),
  on(setProcessPartnerInactive, (state) => ({
    ...state,
    buttonLoading: true,
  })),
  on(setProcessPartnerInactiveSuccess, (state) => ({
    ...state,
    buttonLoading: false,
  })),
  on(searchProcessPartners, (state) => {
    return {
      ...state,
      loading: true,
    };
  }),
  on(searchProcessPartnersSuccess, (state, { processPartners }) => {
    return {
      ...state,
      processPartners,
      loading: false,
    };
  }),
  on(searchProcessPartnersFailure, (state) => {
    return {
      ...state,
      loading: false,
    };
  }),
  on(loadProcessPartnerById, (state) => {
    return {
      ...state,
      loading: true,
    };
  }),
  on(loadProcessPartnerByIdSuccess, (state, action) => {
    return {
      ...state,
      processPartner: action.processPartner,
      loading: false,
    };
  }),
  on(loadProcessPartnerByIdFailure, (state) => {
    return {
      ...state,
      loading: false,
    };
  })
);
